module.exports = __webpack_public_path__ + "static/media/thermometer-half.85a4f9f2.svg";